import React, { Component } from "react";
import Modal from "react-responsive-modal";
import ImageButton from "../2/Controls/ImageButton";
import "./CustomerMember.css";

class CustomerMember extends Component {
  constructor() {
    super();
    this.state = {
      showSelection: false,
      customField1DisplayName: "Custom Field 1",
      customField2DisplayName: "Custom Field 2",
      customField3DisplayName: "Custom Field 3",
      customField4DisplayName: "Custom Field 4",
      customField5DisplayName: "Custom Field 5",
      customField6DisplayName: "Custom Field 6",
    };
    this.onSelected = this.onSelected.bind(this);
  }

  componentDidMount() {
    // let showSelection = false;
    // let selectedRecord = null;
    this.props.config.CustomFields.map((customField) => {
      if (customField.ModuleName === "Customer") {
        let customField1DisplayName =
          customField.CustomField1Name.trim() === ""
            ? "Custom Field 1"
            : customField.CustomField1Name.trim();
        let customField2DisplayName =
          customField.CustomField2Name.trim() === ""
            ? "Custom Field 2"
            : customField.CustomField2Name.trim();
        let customField3DisplayName =
          customField.CustomField3Name.trim() === ""
            ? "Custom Field 3"
            : customField.CustomField3Name.trim();
        let customField4DisplayName =
          customField.CustomField4Name.trim() === ""
            ? "Custom Field 4"
            : customField.CustomField4Name.trim();
        let customField5DisplayName =
          customField.CustomField5Name.trim() === ""
            ? "Custom Field 5"
            : customField.CustomField5Name.trim();
        let customField6DisplayName =
          customField.CustomField6Name.trim() === ""
            ? "Custom Field 6"
            : customField.CustomField6Name.trim();
        this.setState({
          customField1DisplayName: customField1DisplayName,
          customField2DisplayName: customField2DisplayName,
          customField3DisplayName: customField3DisplayName,
          customField4DisplayName: customField4DisplayName,
          customField5DisplayName: customField5DisplayName,
          customField6DisplayName: customField6DisplayName,
        });
      }
    });
    // if (this.props.customer) {
    //   if (!this.props.selectedRecord) {
    //     if (this.props.customer.hasOwnProperty("Members")) {
    //       if (this.props.customer.Members.length > 1) {
    //         showSelection = true;
    //         selectedRecord = this.props.customer.Members[0];
    //         this.props.onChange(selectedRecord);
    //       } else if (this.props.customer.Members.length === 1) {
    //         selectedRecord = this.props.customer.Members[0];
    //         this.props.onChange(selectedRecord);
    //       }
    //     }
    //   }
    // }
    // this.setState({ showSelection: showSelection });
  }

  onSelected(index) {
    let member = this.props.customer.Members[index];
    this.setState({ showSelection: false });
    this.props.onChange(member);
  }

  render() {
    return (
      <React.Fragment>
        <div className="customer-member">
          {this.props.selectedRecord && (
            <div className="customer-member-selected">
              <div
                className="customer-member-selected-left"
                onClick={() => {
                  if (this.props.customer.Members.length > 1) {
                    this.setState({ showSelection: true });
                  }
                }}
              >
                <div>
                  {this.props.selectedRecord.FirstName}{" "}
                  {this.props.selectedRecord.LastName}
                </div>
                {this.props.selectedRecord.PhoneNo !== "" && (
                  <div className="customer-member-text-small">
                    <i className="fa fa-phone"></i>{" "}
                    {this.props.selectedRecord.PhoneNo}
                  </div>
                )}
                {/* {this.props.selectedRecord.EmailID !== "" && (
                  <div>Email ID: {this.props.selectedRecord.EmailID}</div>
                )} */}
              </div>
              <div className="customer-member-selected-right">
                <ImageButton
                  type="remove"
                  onClick={() => this.props.onChange(null)}
                />
              </div>
            </div>
          )}
          {!this.props.selectedRecord && (
            <div
              className="customer-member-not-selected"
              onClick={() => {
                if (this.props.customer.Members.length > 1) {
                  this.setState({ showSelection: true });
                }
              }}
            >
              <div>Please select member</div>
              <div className="customer-member-text-small">
                {this.props.customer.Members.length} member(s)
              </div>
            </div>
          )}
        </div>
        <Modal
          open={this.state.showSelection}
          onClose={() => this.setState({ showSelection: false })}
          center
        >
          {this.state.showSelection && (
            <div style={{ width: "300px" }}>
              <h3 style={{ marginTop: "0px" }}>Member Selection</h3>
              <div className="box-body">
                {this.props.customer.Members.map((c, index) => (
                  <button
                    type="button"
                    onClick={() => this.onSelected(index)}
                    className="btn btn-default btn-block btn-flat btn-lg"
                    style={{
                      padding: "10px",
                      //   height: "100px",
                      whiteSpace: "normal",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "15px",
                        marginLeft: "5px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                      className="pull-left"
                    >
                      <div>
                        Name: {c.FirstName} {c.LastName}
                      </div>
                      {c.PhoneNo !== "" && <div>Mobile No: {c.PhoneNo}</div>}
                      {c.EmailID !== "" && <div>Email ID: {c.EmailID}</div>}
                      {c.CustomField1 !== "" && (
                        <div>
                          {this.state.customField1DisplayName}: {c.CustomField1}
                        </div>
                      )}
                      {c.CustomField2 !== "" && (
                        <div>
                          {this.state.customField2DisplayName}: {c.CustomField2}
                        </div>
                      )}
                      {c.CustomField3 !== "" && (
                        <div>
                          {this.state.customField3DisplayName}: {c.CustomField3}
                        </div>
                      )}
                      {c.CustomField4 !== "" && (
                        <div>
                          {this.state.customField4DisplayName}: {c.CustomField4}
                        </div>
                      )}
                      {c.CustomField5 !== "" && (
                        <div>
                          {this.state.customField5DisplayName}: {c.CustomField5}
                        </div>
                      )}
                      {c.CustomField6 !== "" && (
                        <div>
                          {this.state.customField6DisplayName}: {c.CustomField6}
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </Modal>
      </React.Fragment>
    );
  }
}

export default CustomerMember;
